import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative'
  },

  block: {
    position: 'absolute',
    bottom: '0',
    height: '81px',
    width: '100%',
    background: '#e9e9e9'
  },

  chat: {
    position: 'absolute',
    right: '16px',
    bottom: '16px',
    left: '16px',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #F0F0F0',
    borderRadius: '8px',
    boxSizing: 'border-box',
    boxShadow: '0px 16px 24px rgba(0, 0, 0, 0.08)',
    padding: '16px',
    background: 'white',
    [theme.breakpoints.down('md')]: {
      border: 'solid 1px grey',
      right: 8,
      left: 8
    }
  },

  suggestions: {
    position: 'absolute',
    bottom: 'calc(100% + 4px)',
    left: '0',
    right: '0',
    display: 'flex',
    flexDirection: 'column',
    borderTop: '1px solid #eee',
    borderRadius: '8px',
    boxSizing: 'border-box',
    maxHeight: '300px',
    padding: '24px 16px 16px 16px',
    overflowY: 'auto',
    background: '#fff',
    cursor: 'pointer',

    '&::-webkit-scrollbar': {
      width: '6px'
    },

    '&::-webkit-scrollbar-track': {
      background: '#8F8F8F',
      opacity: '0.2',
      borderRadius: '8px'
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.primary.main,
      borderRadius: '8px'
    }
  }
}))

export default useStyles
